<template>

	<div class="modal fade" :id="'popUpSchedaUtente'+rs" role="dialog">
	    <div class="modal-dialog modal-xl">
            <div class="modal-content">
                <div class="modal-header bg-secondary text-white border-0">
					<h5 class="modal-title">
						<i class="ph-list icon-modal-size me-2"></i><span class="me-2">Scheda:</span>{{ utente.persona.NOME }} {{ utente.persona.COGNOME }} 
					</h5>
					<button type="button" class="btn btn-light btn-sm btn-icon border-transparent rounded-pill" data-bs-dismiss="modal"><i class="ph-x icon-x-size"></i></button>
                </div>
                <div class="modal-body p-2" style="height: 33rem;"> 

                    <div class="card card-noshadow mb-0">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-12 col-sm-12 col-md-2 col-lg-2">
                                    <div class="sidebar-content">
                                        <div class="card sidebar-section-body text-center p-2 mb-0">
                                            <div class="card-img-actions d-inline-block">
                                                <img v-if="utente.ID_UTENTE > 0 && utente.URL_AVATAR != 'placeholder.jpg'" :src="filters.getImgPath('USERS',utente.URL_AVATAR)" class="img-fluid squared-circle rounded-0" alt="" width="215" style="max-height: 230px;" />
                                                <span v-if="utente.URL_AVATAR == 'placeholder.jpg' || utente.ID_UTENTE == 0">
                                                    <img src="../assets/images/placeholders/placeholder.jpg" class="img-fluid rounded-circle" width="150" height="150" alt="">
                                                </span>
                                                <div class="card-img-actions-overlay card-img rounded-circle">
                                                    <a href="#" class="btn btn-outline-white btn-icon rounded-pill" v-on:click="uploadImmagineUtente()">
                                                        <i class="ph-pencil"></i>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>

                                        <ul class="nav nav-sidebar" role="tablist">
                                            <li class="nav-item" role="presentation">
                                                <a :href="'#profile-'+rs" id="datiPersonali" class="nav-link active" data-bs-toggle="tab" aria-selected="true" role="tab" v-on:click="tabSelezionato = 'datiPersonali'" style="padding-left: 5px;" tabindex="1">
                                                    <i class="ph-user me-2"></i>Dati Personali
                                                </a>
                                            </li>
                                            <li v-show="utente.ID_UTENTE > 0 && $root.utente.FK_ID_LIVELLO > 2" class="nav-item" role="presentation">
                                                <a :href="'#schedule-'+rs" class="nav-link" data-bs-toggle="tab" aria-selected="false" role="tab" v-on:click="tabSelezionato='datiAziendali'" style="padding-left: 5px;" tabindex="2">
                                                    <i class="ph-calendar me-2"></i>Dati Aziendali
                                                </a>
                                            </li>
                                            <li v-show="utente.ID_UTENTE > 0 && utente.FK_ID_LIVELLO == 5" class="nav-item" role="presentation">
                                                <a :href="'#friends-'+rs" class="nav-link" data-bs-toggle="tab" aria-selected="false" role="tab" v-on:click="tabSelezionato='friends'" style="padding-left: 5px;" tabindex="3">
                                                    <i class="ph-users me-2"></i>Parenti/amici
                                                </a>
                                            </li>
                                            <li v-show="utente.ID_UTENTE > 0 && utente.FK_ID_LIVELLO == 5" class="nav-item" role="presentation">
                                                <a :href="'#orders-'+rs" class="nav-link" data-bs-toggle="tab" aria-selected="false" role="tab" v-on:click="tabSelezionato='pratiche'" style="padding-left: 5px;" tabindex="4">
                                                    <i class="ph-bag me-2"></i>Pratiche
                                                </a>
                                            </li>
                                            <li v-show="utente.ID_UTENTE > 0 && $root.utente.FK_ID_LIVELLO > 2" class="nav-item" role="presentation">
                                                <a :href="'#cards-'+rs" class="nav-link" data-bs-toggle="tab" aria-selected="false" role="tab" v-on:click="tabSelezionato='tessere'" style="padding-left: 5px;" tabindex="5">
                                                    <i class="ph-cards me-2"></i>Tessere
                                                </a>
                                            </li>
                                            <li v-show="utente.ID_UTENTE > 0 && $root.utente.FK_ID_LIVELLO > 2" class="nav-item" role="presentation">
                                                <a :href="'#notification-'+rs" class="nav-link" data-bs-toggle="tab" aria-selected="false" role="tab" v-on:click="tabSelezionato='notifiche'" style="padding-left: 5px;" tabindex="6">
                                                    <i class="ph-vibrate me-2"></i>Notifiche
                                                </a>
                                            </li>
                                            <li v-show="utente.ID_UTENTE > 0" class="nav-item" role="presentation">
                                                <a :href="'#testi-'+rs" class="nav-link" data-bs-toggle="tab" aria-selected="false" role="tab" v-on:click="tabSelezionato='contenuti'" style="padding-left: 5px;" tabindex="7">
                                                    <i class="ph-text-t me-2"></i>Contenuti 
                                                </a>
                                            </li>
                                            <li v-show="this.utente.FK_ID_LIVELLO < 3 && utente.ID_UTENTE > 0" class="nav-item" role="presentation">
                                                <a :href="'#roles-'+rs" class="nav-link" data-bs-toggle="tab" aria-selected="false" role="tab" v-on:click="tabSelezionato='permessi'" style="padding-left: 5px;" tabindex="8">
                                                    <i class="ph-list me-2"></i>Permessi
                                                </a>
                                            </li>
                                            <li v-show="this.utente.FK_ID_LIVELLO < 3 && utente.ID_UTENTE > 0" class="nav-item" role="presentation">
                                                <a :href="'#notifiche-'+rs" class="nav-link" data-bs-toggle="tab" aria-selected="false" role="tab" v-on:click="tabSelezionato='notifiche'" style="padding-left: 5px;" tabindex="9">
                                                    <i class="ph-bell me-2"></i>Notifiche
                                                </a>
                                            </li>
                                            <li v-show="utente.ID_UTENTE > 0 && $root.utente.FK_ID_LIVELLO < 4" class="nav-item" role="presentation">
                                                <a :href="'#password-'+rs" class="nav-link" data-bs-toggle="tab" aria-selected="false" role="tab" v-on:click="tabSelezionato='configurazioni'" style="padding-left: 5px;" tabindex="10">
                                                    <i class="ph-gear me-2"></i>Configurazioni
                                                </a>
                                            </li>
                                            <li v-show="utente.ID_UTENTE > 0" class="nav-item" role="presentation">
                                                <a :href="'#firme-'+rs" class="nav-link" data-bs-toggle="tab" aria-selected="false" role="tab" v-on:click="tabSelezionato='configurazioneEmail'" style="padding-left: 5px;" tabindex="11">
                                                    <i class="ph-envelope me-2"></i>Configurazione Email
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                
                                </div>
                                <div class="col-12 col-md-10 col-lg-10">
                                    <div class="tab-content flex-fill">
                                        
                                        <div class="tab-pane fade active show" :id="'profile-'+rs" role="tabpanel">
                                            <h5 class="label-bar"><i class="fad fa-user fa-fw me-1"></i> Dati Personali</h5>
                                            <div class="box-28"> 
            
                                                <PersonaFisica v-model="utente.persona" :ref="'pf'"></PersonaFisica>

                                                <hr class="m-2" v-show="utente.ID_UTENTE == 0" />

                                                <div class="row" v-show="utente.ID_UTENTE == 0">
                                                    <div class="col-6 col-md-4"> 
                                                        <label class="form-label text-danger mb-1">Livello</label>
                                                        <select class="form-select form-select-sm" v-model="utente.FK_ID_LIVELLO">
                                                            <option v-for="livello in $root.arrayLivelli" v-bind:value="livello.ID_LIVELLO" v-bind:key="livello.ID_LIVELLO" v-show="livello.ID_LIVELLO > 1">{{ livello.DESCRIZIONE }}</option>
                                                        </select>
                                                    </div>
                                                    <div class="col-6 col-md-8"> 
                                                        <div class="row">
                                                            <div class="col-6 col-md-6">
                                                                <label class="form-label text-danger mb-1">Password</label>
                                                                <input autocomplete="off" type="password" class="form-control form-control-sm" :tabindex="1111" v-model="utente.PASSWORD">
                                                            </div>
                                                            <div class="col-6 col-md-6">
                                                                <label class="form-label text-danger mb-1">Conferma password</label>
                                                                    <input autocomplete="off" type="password" class="form-control form-control-sm" :tabindex="1111112" v-model="utente.CONFERMA_PASSWORD">
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                
                                            </div>
                                        </div>

                                        <div class="tab-pane fade" :id="'schedule-'+rs" role="tabpanel">
                                            <h5 class="label-bar"><i class="fad fa-user fa-fw me-1"></i> Dati Aziendali</h5>
                                            <div class="box-28">
                                                <PersonaGiuridica></PersonaGiuridica>   
                                            </div>  
                                        </div>

                                        <div class="tab-pane fade" :id="'friends-'+rs" role="tabpanel">
                                            <h5 class="label-bar"><i class="fad fa-users fa-fw me-1"></i> Gestione parenti/amici</h5>
                                            <div class="tableFixHead tableFixHeadRoles">
                                                <table class="table table-hover table-striped table-bordered">
                                                    <thead class="sticky-top">
                                                        <tr class="bg-secondary text-white">
                                                            <th class="table-head-sm-2" style="width: 6.6%;">#</th> 
                                                            <th class="table-head-sm-2" style="">Cognome e Nome</th> 
                                                            <th class="table-head-sm-2" style="width: 20%;">Ruolo</th>  
                                                        </tr>
                                                    </thead> 
                                                    <tbody>
                                                        <tr v-for="amico in utente.amici" v-bind:key="amico.ID_UTENTE" >
                                                            <td>
                                                                <img v-if="amico.ID_UTENTE > 0" :src="filters.getImgPath('USERS',amico.URL_AVATAR)" class="rounded shadow" alt="" :width="30" ></td>
                                                            <td>
                                                                <span class="text-primary fw-bold text-uppercase cursor-pointer" >{{ amico.SESSO == 1 ? 'Mr' : 'Mrs' }} - {{ amico.NOME }} {{ amico.COGNOME }}</span><!-- v-on:click="modificaUtente(utente)" -->
                                                                <span class="badge badge-danger badge-xs font-size-xs float-end cursor-pointer"  style="padding: 0.20rem 0.3rem !important;"><i class="fal fa-info fa-fw"></i> Note</span><br /><!-- v-on:click="showNoteUtente(utente)" -->
                                                                <a class="badge bg-light rounded-0 badge-xs font-size-xs text-dark me-1" style="border: 1px #dddddd solid; padding: 0.18rem 0.3rem !important;" v-bind:href="`mailto:${amico.EMAIL}`"><i class="fal fa-envelope fa-fw"></i> {{ utente.EMAIL }}</a>
                                                                <a class="badge bg-light rounded-0 badge-xs font-size-xs text-dark" style="border: 1px #dddddd solid; padding: 0.18rem 0.3rem !important;" v-bind:href="`tel:${amico.TELEFONO}`"><i class="fal fa-phone fa-fw"></i> {{utente.TELEFONO}}</a>
                                                                <a class="badge bg-light rounded-0 badge-xs font-size-xs text-dark cursor-pointer float-end" style="border: 1px #dddddd solid; padding: 0.18rem 0.3rem !important;margin-top: 2.5px;" ><i class="fal fa-key fa-fw" data-popup="tooltip" title="" data-original-title="Reset Password"></i> Reset Password</a><!-- v-on:click="resetPassword(utente)" -->
                                                            </td> 
                                                            <td style="">
                                                                Titolare
                                                                <span class="badge badge-secondary badge-xs font-size-xs cursor-pointer" v-on:click="login(amico)"><i class="fal fa-sign-in-alt fa-fw"></i> Accedi ora</span>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>

                                        <div class="tab-pane fade" :id="'orders-'+rs" role="tabpanel">
                                            <h5 class="label-bar"><i class="fad fa-shopping-bag fa-fw me-1"></i> Elenco Pratiche</h5>
                                            <div class="box-28">       
                                                ?????
                                            </div>
                                        </div>

                                        <div class="tab-pane fade" :id="'cards-'+rs" role="tabpanel">
                                            <h5 class="label-bar"><i class="fad fa-bell fa-fw me-1"></i> Elenco Tessere</h5>
                                            <div class="box-28">
                                                <table class="table table-hover table-striped table-bordered">
                                                    <thead>
                                                        <tr>
                                                            <th class="table-head-sm-2" style="width: 7%;">#</th> 
                                                            <th class="table-head-sm-2" style="width: 5%;">Sesso</th> 
                                                            <th class="table-head-sm-2" style="">Cognome e Nome</th> 
                                                            <th class="table-head-sm-2" style="width: 17%;">Email</th>  
                                                            <th class="table-head-sm-2" style="width: 20%;">Telefono</th>  
                                                            <th class="table-head-sm-2" style="width: 5.4%;">Azioni</th> 
                                                        </tr>
                                                    </thead> 
                                                    <tbody>
                                                        <tr>
                                                            <td>V</td> 
                                                            <td>Mr </td> 
                                                            <td>Castelforte Egidio </td> 
                                                            <td style="text-align: center;">e.castelforte@gmail.com</td> 
                                                            <td style="text-align: center;">+39 3335383890</td> 
                                                            <td style="text-align: center;"><button class="btn btn-xs btn-block btn-default"> ... </button></td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div> 
                                        </div>

                                        <div class="tab-pane fade" :id="'notification-'+rs" role="tabpanel">
                                            <h5 class="label-bar"><i class="fad fa-user fa-fw me-1"></i> Notifiche</h5>
                                            <div class="box-28">

                                            </div>  
                                        </div>

                                        <div class="tab-pane fade" :id="'testi-'+rs" role="tabpanel">
                                            <h5 class="label-bar"><i class="fad fa-text fa-fw me-1"></i> Gestione Contenuti</h5>
                                            <div class="box-28">
                                                <div class="alert alert-primary border-0 alert-dismissible fade show">
                                                    Scrivi in questo spazio, note inerenti l'utente.
                                                    <button type="button" class="btn-close" data-bs-dismiss="alert"></button>
                                                </div>
                                                <ckeditor :editor="editor" v-model="utente.NOTE" :config="editorConfig"></ckeditor>                                     
                                            </div>
                                        </div>

                                        <div class="tab-pane fade" :id="'roles-'+rs" role="tabpanel">
                                            <h5 class="label-bar mb-1"><i class="fad fa-list fa-fw me-1"></i> Gestione Permessi </h5>
                                            <div class="row mb-1">
                                                <div class="col-12 col-md-6">
                                                    <input type="text" class="form-control form-control-sm" placeholder="Descrizione" v-model="searchGruppi.DESCRIZIONE.VALUE" style="width: 315px !important;">
                                                </div>
                                                <div class="col-12 col-md-6 d-flex align-items-center justify-content-end">
                                                    <a href="#" class="btn btn-outline-secondary btn-sm me-1" @click.prevent="filters.openPopUp('popUpHelpPermessi'+rs)" title="Come funziona la matrice permessi">
                                                        <i class="ph-question"></i>
                                                    </a>
                                                    <select class="form-select form-select-sm" placeholder="Eredita Profilo" v-model="idGruppoProfiloSelezionato" @change="updateProfiloUtente()" style="width: 9rem !important; margin-right: 1px !important;">
                                                        <option v-for="profilo in arrayGruppi" v-show="profilo.FLG_PROFILO == 1" v-bind:key="profilo.ID_GRUPPO" v-bind:value="profilo.ID_GRUPPO"> {{ profilo.DESCRIZIONE }}</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div class="tableFixHead tableFixHeadRoles">
                                                <table class="table table-bordered table-hover table-striped table-togglable">
                                                    <thead class="sticky-top">
                                                        <tr class="bg-secondary text-white">
                                                            <th class="table-head-sm">Gruppo <span class="float-end me-3">All</span></th>
                                                            <th v-for="op in opzioniVerbi" :key="op.ICONA" class="table-head-sm text-center" style="min-width:70px;">{{ op.DESCRIZIONE }}</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr v-for="gruppo in paginatedListGruppi.arr" :key="gruppo.ID_GRUPPO" v-show="gruppo.FLG_PROFILO == 0">
                                                            <td>
                                                                {{ gruppo.DESCRIZIONE }}
                                                                <span class="float-end"><ISwitch @toggle="updateGruppoUtente(gruppo)" :size="'sm'" v-model="gruppo.SELEZIONATO" style="z-index:0;"></ISwitch></span>
                                                            </td>
                                                            <td class="text-center" v-for="op in opzioniVerbi" :key="op.ICONA">
                                                                <template v-if="getFunzByVerb(gruppo, op.DESCRIZIONE)">
                                                                    <ISwitch @toggle="updateFunzionalitaUtente(getFunzByVerb(gruppo, op.DESCRIZIONE))" :size="'sm'" v-model="getFunzByVerb(gruppo, op.DESCRIZIONE).SELEZIONATO" style="z-index:0;"></ISwitch>
                                                                </template>
                                                                <span v-else class="text-muted">—</span>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                            <!--
                                            <div class="row ">
                                                <div class="col-12">
                                                    <div v-bind:style="getStyle(0)" class="dizionarioContainer" style="overflow:auto;" v-for="gruppo in arrayGruppi" v-bind:key="gruppo.ID_GRUPPO"  >
                                                        <div class="dizionario" style="margin:5px; float:left;" v-bind:style="getStyleDizionario(0)"  >
                                                            <div class="float-start"><i class="far" ></i> <span >{{gruppo.DESCRIZIONE}}</span></div>
                                                            <div class="float-end">
                                                                <ISwitch @toggle="updateGruppoUtente(gruppo)" :size="'sm'" v-model="gruppo.SELEZIONATO" style="z-index: 0;"></ISwitch>                                              
                                                            </div>                                                                                                    
                                                        </div>
                                                        <div v-bind:style="getStyle(1)" class="dizionarioContainer" style="overflow:auto; border-left: 1px solid #bbb" v-for="funzionalita in gruppo.FUNZIONALITA"  v-bind:key="funzionalita.ID_FUNZIONALITA" >
                                                            <div v-bind:style="getStileBorderWidth(1)" style="width:60px; border-top: 1px solid rgb(187, 187, 187); float: left; height: 22px; margin-top: 26px; margin-left: -20px;"></div>
                                                            <div class="dizionario" style="margin:5px;float:left;" v-bind:style="getStyleSubDizionario(1)" >
                                                                <div class="float-start">
                                                                    <i class="far"></i> <span >{{funzionalita.DESCRIZIONE}}</span>
                                                                </div>
                                                                <div class="float-end">
                                                                    <ISwitch @toggle="updateFunzionalitaUtente(funzionalita)" :size="'sm'" v-model="funzionalita.SELEZIONATO" style="z-index: 0;"></ISwitch>  
                                                                </div>                                                        
                                                            </div>
                                                        </div>
                                                    </div>                                            
                                                </div>                                                                               
                                            </div>
                                            -->
                                        </div>

                                        <div class="tab-pane fade" :id="'notifiche-'+rs" role="tabpanel">
                                            <h5 class="label-bar mb-1"><i class="fad fa-bell fa-fw me-1"></i> Gestione Notifiche </h5>
                                            <div class="row mb-1">
                                                <div class="col-12 col-md-6">
                                                    <input type="text" class="form-control form-control-sm" placeholder="Descrizione" style="width: 315px !important;">
                                                </div>
                                                <div class="col-12 col-md-6 text-end">
                                                    <button class="btn btn-sm btn-success me-1" @click="abilitaNotificheSelezionate(utente)"><i class="far fa-check-square fa-fw me-1"></i>Abilita selezionati</button>
                                                    <button class="btn btn-sm btn-danger" @click="disabilitaNotificheSelezionate(utente)"><i class="far fa-square fa-fw me-1"></i>Disabilita selezionati</button>
                                                </div>
                                            </div>
                                            <div class="tableFixHead tableFixHeadRoles">
                                                <table class="table table-bordered table-hover table-striped table-togglable">
                                                    <thead class="sticky-top">
                                                        <tr class="bg-secondary text-white">
                                                            <th class="table-head-sm" style="width:3%;"><input id="chkAllNotifiche" v-on:click="filters.selectAll('chkAllNotifiche', $root.arrayTipologieNotifiche)" type="checkbox"></th>
                                                            <th class="table-head-sm" style="">Titolo Notifica</th>
                                                            <th class="table-head-sm" style="width: 10%;">Azione</th>
                                                        </tr>
                                                    </thead> 
                                                    <tbody>
                                                        <tr v-for="noti in $root.arrayTipologieNotifiche" v-bind:key="noti.ID_TIPOLOGIA_NOTIFICA" v-bind:value="noti.ID_TIPOLOGIA_NOTIFICA">
                                                            <td class="text-center"><input type="checkbox" v-bind:true-value="1" v-bind:false-value="0" v-model="noti.SELEZIONATO"></td>
                                                            <td style="">
                                                                {{noti.TITOLO}}
                                                            </td>
                                                            <td class="text-center " >
                                                                <ISwitch @toggle="updateNotificaUtente(noti,this.utente)" v-model="noti.FLG_ATTIVO" :size="'sm'" style="z-index: 0;"></ISwitch>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>

                                        <div class="tab-pane fade" :id="'password-'+rs" role="tabpanel">
                                            <h5 class="label-bar"><i class="fad fa-cogs fa-fw me-1"></i> Configurazioni Personali</h5>
                                            <!-- 17/04/2023 - UTILIZZIAMO LA CORE_OPZIONI_UTENTE (IN QUESTA TABELLA NON CI SONO RIFERIMENTI AD OPZIONI
                                                 REALMENTE CODIFICATE MA NEL CAMPO LABEL VIENE INSERITA LA DESCRIZIONE DELL'OPZIONE MENTRE NEL CAMPO VALORE IL RELATIVO VALORE) -->
                                            <div class="box-28">
                                                <form action="#">
                                                    <div class="row mb-1">
                                                        <label class="col-lg-3 col-form-label">SITO WEB:</label>
                                                        <div class="col-lg-1">
                                                            <span class="btn btn-light btn-sm" v-on:click="utente.enti = filters.select2AddAll(utente.enti,filters.toSelect2($root.arrayEnti,'ID_ENTE','LABEL'))">Tutti</span>
                                                        </div>
                                                        <div class="col-lg-8">
                                                            <Multiple v-bind:options="filters.toSelect2($root.arrayEnti,'ID_ENTE','LABEL')" v-model="utente.enti"></Multiple>
                                                        </div>
                                                    </div>
                                                    <div class="row mb-1" v-for="opzione in arrayOpzioniUtente" v-bind:key="opzione.FK_ID_TIPOLOGICA">
                                                        <label class="col-lg-3 col-form-label">{{ opzione.LABEL }}:</label>
                                                        <div class="col-lg-9">
                                                            <select v-model="opzione.VALORE" class="form-select form-select-sm" :disabled="opzione.FLG_MODIFICABILE == 0 && $root.utente.FK_ID_LIVELLO > 1" >
                                                                <option v-for="opz in opzione.OPZIONI" v-bind:value="opz.ID_OPZIONE_TIPOLOGICA" v-bind:key="opz.DESCRIZIONE" v-show="opzione.LABEL != 'RUOLI' ? true : checkShowRuolo(opz)">{{ opz.DESCRIZIONE }}</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <!-- OTP / Codice sicurezza -->
                                                    <div class="row mb-1">
                                                        <label class="col-lg-3 col-form-label">OTP:</label>
                                                        <div :class="utente.FLG_OTP == 0 ? 'col-lg-3' : 'col-lg-9'">
                                                            <select v-model="utente.FLG_OTP" class="form-select form-select-sm"
                                                                    :disabled="$root.isGod && utente.ID_UTENTE == $root.utente.ID_UTENTE">
                                                                <option :value="1">Abilitato</option>
                                                                <option :value="0">Disabilitato</option>
                                                            </select>
                                                        </div>
                                                        <div class="col-lg-6" v-if="utente.FLG_OTP == 0">
                                                            <div class="input-group input-group-sm">
                                                                <input type="text" class="form-control"
                                                                       :value="codiceSicurezzaVisibile ? nuovoCodiceSicurezza : ($root.isGod && utente.CODICE_SICUREZZA ? utente.CODICE_SICUREZZA : ((utente.CODICE_SICUREZZA || utente.FLG_CODICE_SICUREZZA) ? '••••••' : ''))"
                                                                       readonly
                                                                       placeholder="Nessun codice impostato" />
                                                                <button class="btn btn-outline-secondary btn-sm" v-on:click.prevent="generaCodiceSicurezza()">
                                                                    {{ (utente.CODICE_SICUREZZA || utente.FLG_CODICE_SICUREZZA) ? 'Rigenera' : 'Genera' }}
                                                                </button>
                                                            </div>
                                                            <small v-if="(utente.CODICE_SICUREZZA || utente.FLG_CODICE_SICUREZZA) && !codiceSicurezzaVisibile">
                                                                <a href="#" v-on:click.prevent="inviaCodiceSicurezza()">Invia per email</a>
                                                            </small>
                                                        </div>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>

                                        <div class="tab-pane fade" :id="'firme-'+rs" role="tabpanel">
                                            <h5 class="label-bar"><i class="ph-envelope me-2"></i> Configurazione Email</h5>
                                            <div class="box-28">

                                                <!-- PASSWORD EMAIL -->
                                                <div class="row mb-3">
                                                    <div class="col-12 col-md-6">
                                                        <label class="form-label mb-1">Password Email (SMTP/IMAP)</label>
                                                        <div class="input-group input-group-sm">
                                                            <input autocomplete="off" type="password" class="form-control form-control-sm"
                                                                   v-model="utente.PASSWORD_EMAIL" placeholder="Password email" />
                                                            <button class="btn btn-warning btn-sm" v-on:click="salvaPasswordEmail()">
                                                                <i class="ph-floppy-disk me-1"></i> Salva
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>

                                                <hr class="m-2" />

                                                <!-- FIRME PERSONALI -->
                                                <div class="row mb-2">
                                                    <div class="col-12">
                                                        <h6 class="label-bar mb-1"><i class="ph-pen me-1"></i> Le mie Firme Email</h6>
                                                    </div>
                                                </div>

                                                <!-- List of existing personal signatures -->
                                                <div class="row mb-2" v-if="arrayFirmePersonali.length > 0">
                                                    <div class="col-12">
                                                        <table class="table table-bordered table-hover table-sm table-striped">
                                                            <thead>
                                                                <tr class="bg-secondary text-white">
                                                                    <th class="table-head-sm">Nome</th>
                                                                    <th class="table-head-sm text-center" style="width: 12%;">Azioni</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr v-for="firma in arrayFirmePersonali" :key="firma.ID_FIRMA">
                                                                    <td class="td-class">{{ firma.NOME }}</td>
                                                                    <td class="td-class text-center">
                                                                        <a href="#" class="me-2" v-on:click.prevent="modificaFirmaPersonale(firma)">
                                                                            <i class="ph-pencil text-warning"></i>
                                                                        </a>
                                                                        <a href="#" v-on:click.prevent="eliminaFirmaPersonale(firma)">
                                                                            <i class="ph-trash text-danger"></i>
                                                                        </a>
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                                <div class="row mb-2" v-else>
                                                    <div class="col-12">
                                                        <span class="text-muted">Nessuna firma personale configurata.</span>
                                                    </div>
                                                </div>

                                                <!-- Add new personal signature form -->
                                                <div class="row mb-2">
                                                    <div class="col-12 col-md-4">
                                                        <label class="form-label mb-1">Nome Firma</label>
                                                        <input autocomplete="off" type="text" class="form-control form-control-sm"
                                                               v-model="nuovaFirma.NOME" placeholder="Es. Firma Professionale" />
                                                    </div>
                                                </div>
                                                <div class="row mb-2">
                                                    <div class="col-12">
                                                        <label class="form-label mb-1">Contenuto Firma</label>
                                                        <ckeditor
                                                            :editor="editorFirma"
                                                            v-model="nuovaFirma.CONTENUTO_HTML"
                                                            :config="editorFirmaConfig">
                                                        </ckeditor>
                                                    </div>
                                                </div>
                                                <div class="row mb-2">
                                                    <div class="col-12 d-flex gap-2">
                                                        <button class="btn btn-primary btn-sm" v-on:click="salvaFirmaPersonale()">
                                                            <i :class="nuovaFirma.ID_FIRMA ? 'ph-floppy-disk' : 'ph-plus'" class="me-1"></i>
                                                            {{ nuovaFirma.ID_FIRMA ? 'Salva Modifiche' : 'Aggiungi Firma' }}
                                                        </button>
                                                        <button class="btn btn-warning btn-sm" v-if="nuovaFirma.ID_FIRMA" v-on:click="resetFirmaPersonaleForm()">
                                                            <i class="ph-arrow-counter-clockwise me-1"></i> Annulla
                                                        </button>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
        
                </div>
				<div class="modal-footer bg-light p-1">
                    <button type="button" class="btn btn-link" data-bs-dismiss="modal">
						<i class="fal fa-sign-out-alt fa-fw me-2"></i><Translate :path="'dizionario.base.BTN_CLOSE'"></Translate>
					</button>
                    <button class="btn btn-secondary float-end" v-show="['datiPersonali', 'contenuti', 'configurazioni'].includes(tabSelezionato)" v-on:click="salvaUtente()"><i class="fal fa-save fa-fw me-1"></i> Salva Modifiche </button>                                   
                </div>                
            </div>
        </div>
    </div>

    <div class="modal fade" :id="'popUpUploadImgUtente'+rs" role="dialog"  tabindex="-1">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header modal-header-2 bg-light text-dark">
                    <h6 class="modal-title">Upload immagine Profilo</h6>
                    <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal"></button>
                </div>
                <div class="modal-body">    
                    <Upload :args="argsUtente" @onsuccess="successCaricamento($event)" @onerror="errorCaricamento($event)"></Upload>
                </div>
                <div class="modal-footer bg-light p-2">
                    <button type="button" class="btn btn-link" data-bs-dismiss="modal">
						<i class="fal fa-sign-out-alt fa-fw me-1"></i> Chiudi 
					</button>
                </div>
            </div>
        </div>
    </div>

    <div class="modal fade" :id="'popUpCodiceSicurezza'+rs" role="dialog" tabindex="-1">
        <div class="modal-dialog modal-sm" role="document">
            <div class="modal-content">
                <div class="modal-header bg-secondary text-white">
                    <h6 class="modal-title"><i class="ph-lock me-2"></i>Codice generato</h6>
                    <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal"></button>
                </div>
                <div class="modal-body text-center py-4">
                    <p class="text-muted mb-2">Il tuo nuovo codice di sicurezza è:</p>
                    <div class="display-5 fw-bold mb-3" style="letter-spacing:6px">{{ nuovoCodiceSicurezza }}</div>
                    <button class="btn btn-outline-secondary btn-sm" v-on:click.prevent="copiaCodiceSicurezza()">
                        <i class="ph-copy me-1"></i>Copia negli appunti
                    </button>
                </div>
                <div class="modal-footer bg-light p-2 d-block text-center">
                    <p class="text-muted small mb-2">Annota il codice, poi chiudi e salva.</p>
                    <button type="button" class="btn btn-link btn-sm" data-bs-dismiss="modal">
                        <i class="fal fa-sign-out-alt fa-fw me-1"></i>Chiudi
                    </button>
                </div>
            </div>
        </div>
    </div>

    <div class="modal fade" :id="'popUpHelpPermessi'+rs" role="dialog" tabindex="-1">
        <div class="modal-dialog modal-md" role="document">
            <div class="modal-content">
                <div class="modal-header bg-secondary text-white">
                    <h6 class="modal-title"><i class="ph-question me-2"></i> Come funziona la matrice permessi</h6>
                    <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal"></button>
                </div>
                <div class="modal-body p-3">
                    <p class="text-muted mb-3">La matrice mostra, per ogni gruppo di funzionalità, quali azioni sono abilitate per questo utente.</p>
                    <table class="table table-bordered table-sm mb-3">
                        <thead class="table-secondary">
                            <tr>
                                <th>Elemento</th>
                                <th>Significato</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td><strong>Righe</strong></td>
                                <td>Gruppi di funzionalità (es. <em>Progetti</em>, <em>Note Spese</em>)</td>
                            </tr>
                            <tr>
                                <td><strong>Colonne</strong></td>
                                <td>Verbi/azioni: <code>LEGGI</code>, <code>CREA</code>, <code>MODIFICA</code>, <code>ELIMINA</code>, <code>ESPORTA</code>, <code>IMPORTA</code>, <code>APPROVA</code>, <code>ADMIN</code></td>
                            </tr>
                            <tr>
                                <td><strong>Toggle cella</strong></td>
                                <td>Abilita/disabilita la singola funzionalità per questo utente</td>
                            </tr>
                            <tr>
                                <td><strong>Toggle "All"</strong></td>
                                <td>Abilita/disabilita l'intero gruppo in blocco</td>
                            </tr>
                            <tr>
                                <td><strong>Cella con <code>—</code></strong></td>
                                <td>Non esiste una funzionalità con quel verbo per quel gruppo</td>
                            </tr>
                        </tbody>
                    </table>
                    <div class="alert alert-info border-0 py-2 px-3 mb-0">
                        <i class="ph-info me-1"></i> <strong>Eredita Profilo</strong>: seleziona un profilo predefinito per copiarne i permessi su questo utente.
                    </div>
                </div>
                <div class="modal-footer bg-light p-2">
                    <button type="button" class="btn btn-link btn-sm" data-bs-dismiss="modal"><i class="fal fa-sign-out-alt fa-fw me-1"></i> Chiudi</button>
                </div>
            </div>
        </div>
    </div>

</template>



<script>

import ISwitch from '@/components/utils/ISwitch.vue'
import Select2 from '@/components/utils/Select2.vue'
import Multiple from '@/components/utils/Multiple.vue'
import Upload from '@/components/utils/Upload.vue'
import CKEditor from '@ckeditor/ckeditor5-vue';
import ClassicEditor from '@/utils/CustomCKEditor';
import PersonaFisica from '@/components/common/PersonaFisica.vue'
import PersonaGiuridica from '@/components/common/PersonaGiuridica.vue'


export default {
    name:"SchedaUtente",

    emits:['updateGriglia','updateUtente'],

    props:['livello'], 

    components:{
        ISwitch,
        Upload,
        PersonaFisica,
        PersonaGiuridica,
        Multiple,
        ckeditor: CKEditor.component
    },	 

    data:function(){
        return{
            filters:global.filters,
            utente : {persona:{},NOTE:'',ID_UTENTE:0,enti:new Array()},
            //CORRISPONDENZA CON ID DELLE TIPOLOGICHE
            idGruppoProfiloSelezionato : 0,
            arrayGruppi:new Array(),
            arrayOpzioniTipologiche:new Array(),
            arrayEnti:new Array(),
            arrayOpzioniUtente:new Array(),
            idTipologicaVerbi: 64,
            searchGruppi:{
                PAGINATION:{LENGTH:0,PAGE_NUMBER:1,PAGE_SIZE:1000000000},
                DESCRIZIONE:{TYPE:'TEXT',VALUE:''},
            },
            rs : utils.generateRandomString(30),
            tabSelezionato : "datiPersonali",
            funzionalitaSelezionata:{},
            editor: ClassicEditor,
            editorConfig: {},
            argsUtente:{
                modalita:'THEB_uploadImgUtente',
            },
            arrayFirmePersonali: [],
            nuovaFirma: { ID_FIRMA: 0, NOME: '', CONTENUTO_HTML: '' },
            editorFirma: ClassicEditor,
            editorFirmaConfig: {
                toolbar: { items: ['bold', 'italic', 'underline', 'link', '|', 'sourceEditing'] }
            },
            nuovoCodiceSicurezza: '',
            codiceSicurezzaVisibile: false,
        }
    },

    methods:{
        chiudi() {
            this.filters.closePopUp('popUpSchedaUtente' + this.rs);
        },

        generaCodiceSicurezza() {
            var codice = Math.floor(100000 + Math.random() * 900000).toString();
            this.nuovoCodiceSicurezza = codice;
            this.codiceSicurezzaVisibile = true;
            this.filters.openPopUp('popUpCodiceSicurezza' + this.rs);
        },

        copiaCodiceSicurezza() {
            navigator.clipboard.writeText(this.nuovoCodiceSicurezza).then(() => {
                utils.alert.success('Codice copiato negli appunti!');
            });
        },

        inviaCodiceSicurezza() {
            utils.ajax('core/login/inviaCodiceSicurezza', { ID_UTENTE: this.utente.ID_UTENTE }, () => {
                utils.alert.success('Codice di sicurezza inviato via email.');
            });
        },

        openSchedaUtente : function(utente){
            if (utente.ID_UTENTE == 0){
                this.utente = utils.clone(utente);
                this.filters.openPopUp('popUpSchedaUtente'+this.rs);
            }
            else{
                utils.ajax("core/utente",{ID_UTENTE:utente.ID_UTENTE}, (response) => {
                    this.utente = response.data.UTENTE;
                    this.argsUtente.ID_UTENTE = this.utente.ID_UTENTE;
                    this.arrayOpzioniTipologiche = response.data.OPZIONI;               
                    this.handlerGetUtente(response);
                    this.filters.openPopUp('popUpSchedaUtente'+this.rs);
                });
            }
            setTimeout(() => {
                var el = document.getElementById('datiPersonali');
                el.click();
            }, 300);
        }, 

        handlerGetUtente:function(response){            
            this.utente = response.data.UTENTE;  
            this.arrayOpzioniTipologiche = response.data.OPZIONI;      
            this.arrayGruppi = new Array();
            this.arrayGruppi = utils.clone(this.$root.arrayGruppi);
            for (var j = 0 ; j < this.arrayGruppi.length ; j++){
                for (var i = 0 ; i < this.utente.gruppi.length ; i++){                        
                    if (this.utente.gruppi[i].ID_GRUPPO == this.arrayGruppi[j].ID_GRUPPO){
                        this.arrayGruppi[j].SELEZIONATO = 1;
                    }
                }
                for (var l = 0 ; l < this.utente.funzionalita.length ; l++){
                    for (var k = 0 ; k < this.arrayGruppi[j].FUNZIONALITA.length ; k++){ 
                        if ( this.utente.funzionalita[l].ID_FUNZIONALITA == this.arrayGruppi[j].FUNZIONALITA[k].ID_FUNZIONALITA ){
                            this.arrayGruppi[j].FUNZIONALITA[k].SELEZIONATO = 1;
                        }
                    }                            
                }
            }     

            // Le opzioni configurabili dell'utente sono le tipologiche del suo modulo, recuperate dinamicamente dal DB:
            // niente FK_ID_TIPOLOGICA scolpiti, la LABEL coincide con SHARED_TIPOLOGICHE.DESCRIZIONE (chiave salvata in CORE_OPZIONI_UTENTE).
            // Modulo in base al livello (mirror della logica core): staff/admin = 21, end-user (livello 5) = 22.
            var idModulo = this.utente.FK_ID_LIVELLO == 5 ? 22 : 21;
            utils.ajax("shared/tipologiche",{FK_ID_MODULO:idModulo}, (responseTip) => {
                if (responseTip.esito != 0){ return; }
                var bloccate = ["RUOLI","TOPBAR"]; // policy UI: non modificabili da chi non e' god (TODO: gestire via permessi)
                this.arrayOpzioniUtente = new Array();
                for (var i = 0 ; i < responseTip.data.length ; i++){
                    var tip = responseTip.data[i];
                    var opzioni = utils.array.select(this.arrayOpzioniTipologiche,"FK_ID_TIPOLOGICA",tip.ID_TIPOLOGICA);
                    if (opzioni.length == 0){ continue; } // tipologica non pertinente a questo utente
                    var riga = {
                        LABEL: tip.DESCRIZIONE,
                        FK_ID_TIPOLOGICA: tip.ID_TIPOLOGICA,
                        FLG_MODIFICABILE: bloccate.includes(tip.DESCRIZIONE) ? 0 : 1,
                        OPZIONI: opzioni,
                        VALORE: ""
                    };
                    for (var j = 0 ; j < this.utente.opzioni.length ; j++){
                        if (this.utente.opzioni[j].LABEL == riga.LABEL){
                            riga.VALORE = this.utente.opzioni[j].VALORE;
                            break;
                        }
                    }
                    this.arrayOpzioniUtente.push(riga);
                }
                // RUOLI: il core la accoda sempre alle OPZIONI ma non appartiene al modulo, quindi il fetch per modulo
                // non la include. Se restano opzioni non mappate dal modulo, sono quelle dei RUOLI: aggiungiamo la riga
                // identificandola a stringa (non per ID), in testa come nell'originale.
                var idsModulo = responseTip.data.map(t => t.ID_TIPOLOGICA);
                var residue = this.arrayOpzioniTipologiche.filter(o => !idsModulo.includes(o.FK_ID_TIPOLOGICA));
                if (residue.length > 0){
                    var idRuoli = residue[0].FK_ID_TIPOLOGICA;
                    var valoreRuoli = utils.array.select(this.utente.opzioni,"LABEL","RUOLI",1)[0];
                    this.arrayOpzioniUtente.unshift({
                        LABEL: "RUOLI",
                        FK_ID_TIPOLOGICA: idRuoli,
                        FLG_MODIFICABILE: 0,
                        OPZIONI: utils.array.select(this.arrayOpzioniTipologiche,"FK_ID_TIPOLOGICA",idRuoli),
                        VALORE: valoreRuoli != undefined ? valoreRuoli.VALORE : ""
                    });
                }
            });
            //this.getTipologieNotificheUtente(this.utente);
        },

        salvaUtente : function(){
            if (this.tabSelezionato == "datiPersonali" || this.tabSelezionato == "contenuti"){
                var api = this.utente.ID_UTENTE > 0 ? "core/utente/update" : "core/utente/insert";
                utils.ajax(api,this.utente, (response) => {
                    if (response.esito == 0){
                        if(this.utente.ID_UTENTE > 0){
                            this.$emit('updateUtente',this.utente.ID_UTENTE);
                        }
                        utils.alert.success(response.messaggio);
                        if (this.utente.ID_UTENTE == 0){
                            this.utente.ID_UTENTE = response.id_inserito;
                        }
                        //if (response.data != undefined){
                        this.$emit("updateGriglia",response.data);
                        // }

                        /*** BLOCCO PER SALVATAGGIO NOTIFICHE ***/
                        if(this.utente.ID_UTENTE == 0){
                            const { FK_ID_MODULO,FK_ID_TIPOLOGIA,FK_ID_UTENTE } = response.notifica || {};
                            if (FK_ID_MODULO && FK_ID_TIPOLOGIA && FK_ID_UTENTE) {
                                this.$root.appoggio.socket.emit('moduleEvent', {FK_ID_MODULO,FK_ID_TIPOLOGIA,FK_ID_UTENTE});
                            } else {
                                console.warn("FK_ID_MODULO o FK_ID_TIPOLOGIA mancanti nella response, evento 'moduleEvent' non emesso.");
                            }
                        }
                        /*** FINE BLOCCO ***/
                    }
                });
            }
            else if (this.tabSelezionato == "configurazioni"){
                var payloadConf = {
                    ID_UTENTE: this.utente.ID_UTENTE,
                    opzioni: this.arrayOpzioniUtente,
                    enti: this.utente.enti,
                    FLG_OTP: this.utente.FLG_OTP
                };
                if (this.codiceSicurezzaVisibile && this.nuovoCodiceSicurezza){
                    payloadConf.CODICE_SICUREZZA = this.nuovoCodiceSicurezza;
                }
                utils.ajax("core/utente/opzioni/update", payloadConf, (response) => {
                    if (response.esito == 0){
                        if (this.codiceSicurezzaVisibile && this.nuovoCodiceSicurezza){
                            if (this.$root.isGod) {
                                this.utente.CODICE_SICUREZZA = this.nuovoCodiceSicurezza;
                            } else {
                                this.utente.CODICE_SICUREZZA = null;
                                this.utente.FLG_CODICE_SICUREZZA = 1;
                            }
                            this.codiceSicurezzaVisibile = false;
                            this.nuovoCodiceSicurezza = '';
                        }
                        utils.alert.success(response.messaggio);
                        this.$emit("updateGriglia", response.data);
                    }
                });
            }

        },
        
        updateGruppoUtente : function (gruppo){
            setTimeout(() => {
                utils.ajax("core/utente/gruppo/update",{ID_GRUPPO:gruppo.ID_GRUPPO,ID_UTENTE:this.utente.ID_UTENTE,SELEZIONATO:gruppo.SELEZIONATO}, (response) => {
                    utils.ajax("core/utente",{ID_UTENTE:this.utente.ID_UTENTE}, (response) => {
                        this.utente = response.data.UTENTE;
                        this.handlerGetUtente(response);                    
                    });
                });                    
            }, 300);
        },	

        getFunzByVerb(gruppo, verb) {
            return (gruppo.FUNZIONALITA || []).find(f => {
                const idx = (f.AZIONE || '').lastIndexOf('_');
                return idx >= 0 && f.AZIONE.substring(idx + 1) == verb;
            }) || null;
        },

        updateFunzionalitaUtente : function (funzionalita){
            setTimeout(() => {
                utils.ajax("core/utente/funzionalita/update",{ID_FUNZIONALITA:funzionalita.ID_FUNZIONALITA,ID_UTENTE:this.utente.ID_UTENTE,SELEZIONATO:funzionalita.SELEZIONATO}, (response) => {
                    utils.ajax("core/utente",{ID_UTENTE:this.utente.ID_UTENTE}, (response) => {
                        this.utente = response.data.UTENTE;
                        this.handlerGetUtente(response);                    
                    });
                });
            }, 300);
        }, 

        updateProfiloUtente : function(){
            utils.ajax("core/utente/profilo/update",{ID_UTENTE:this.utente.ID_UTENTE,ID_GRUPPO:this.idGruppoProfiloSelezionato}, (response) => {
                if (response.esito == 0){
                    utils.ajax("core/utente",{ID_UTENTE:this.utente.ID_UTENTE}, (response) => {
                        this.utente = response.data.UTENTE;
                        this.handlerGetUtente(response);                    
                    });
                }
            });            
        },

        getBorderWidth(livello){
            return (30 + (60*livello))
        }, 

        getStileBorderWidth(){
            var stile = {};
            stile['width'] = this.getBorderWidth() + "px";
            return stile;
        },	

        getStyle:function(livello){
            //var calc = 'calc(100% - '+(100*(this.livello))+'px)';
            var padd = '60px';
            var stile = {};
            stile.width = "100%";
            if (livello > 0){
                stile['margin-left'] = ( 60)+"px";
                stile.width = "calc(100% - "+(60)+"px)";
            }
            return stile;
        },	

        getStyleDizionario:function(livello){
            var stile = {};
            var r = 104 - (20*livello);
            var g = 209 - (20*livello);
            var b = 254 - (20*livello);
            stile.width = "calc(100% - 20px)";
            return stile;
        },	

        getStyleSubDizionario:function(livello){
            var stile = {};
            var r = 104 - (20*livello);
            var g = 209 - (20*livello);
            var b = 254 - (20*livello);
            stile.width = "calc(100% - 60px)";
            return stile;
        },	

        uploadImmagineUtente : function(){
            this.filters.openPopUp("popUpUploadImgUtente"+this.rs);
        },

        successCaricamento:function(){
            this.filters.closePopUp("popUpUploadImgUtente"+this.rs);
            utils.ajax("core/utente",{ID_UTENTE:this.utente.ID_UTENTE}, (response) => {
                this.utente = response.data.UTENTE;
                this.handlerGetUtente(response);  
                this.$emit("updateGriglia",response.data);                  
            });
        },

        errorCaricamento:function(){
            this.filters.closePopUp("popUpUploadImgUtente"+this.rs);
        }, 

        checkShowRuolo : function(ruolo){	
			if (this.utente.FK_ID_LIVELLO != 5){
				if (ruolo.CUSTOM_1 == "" || ruolo.CUSTOM_1 == this.utente.FK_ID_LIVELLO){
					return true;
				}
			}
			else{
				if (ruolo.CUSTOM_1 == this.utente.FK_ID_LIVELLO){
					return true;
				}
			}
			return false;
		},

        updateNotificaUtente : function (noti,utente){
            const payload = {
                ID_TIPOLOGIA_NOTIFICA:noti.FK_TIPOLOGIA_NOTIFICA,
                ID_UTENTE:utente.ID_UTENTE,
                FLG_ATTIVO: noti.FLG_ATTIVO == 1 ? 0 : 1,
            }
            setTimeout(() => {
                utils.ajax("shared/notifiche/utente/update",payload, (response) => {
                    if(response.esito == 0){
                        utils.alert.success(response.messaggio);
                    }
                });
            }, 250);
        },

        abilitaNotificheSelezionate(utente) {
            var sel = utils.array.select(this.$root.arrayTipologieNotifiche, 'SELEZIONATO', 1);
            if (sel.length == 0) { utils.alert.warning('Nessuna notifica selezionata.'); return; }
            utils.alert.confirm('Abilitare ' + sel.length + ' notifiche selezionate?', () => {
                utils.ajax('theb/notifiche/utente/abilita-bulk', {
                    ID_UTENTE: utente.ID_UTENTE,
                    IDS: sel.map(n => n.FK_TIPOLOGIA_NOTIFICA),
                }, (response) => {
                    if (response.esito == 0) {
                        sel.forEach(n => { n.FLG_ATTIVO = 1; });
                        utils.alert.success(response.messaggio);
                    }
                });
            }, this.$root);
        },

        disabilitaNotificheSelezionate(utente) {
            var sel = utils.array.select(this.$root.arrayTipologieNotifiche, 'SELEZIONATO', 1);
            if (sel.length == 0) { utils.alert.warning('Nessuna notifica selezionata.'); return; }
            utils.alert.confirm('Disabilitare ' + sel.length + ' notifiche selezionate?', () => {
                utils.ajax('theb/notifiche/utente/disabilita-bulk', {
                    ID_UTENTE: utente.ID_UTENTE,
                    IDS: sel.map(n => n.FK_TIPOLOGIA_NOTIFICA),
                }, (response) => {
                    if (response.esito == 0) {
                        sel.forEach(n => { n.FLG_ATTIVO = 0; });
                        utils.alert.success(response.messaggio);
                    }
                });
            }, this.$root);
        },

        caricaFirmePersonali: function() {
            utils.ajax("core/utente/firme/personali", {}, (response) => {
                if (response.esito == 0) {
                    this.arrayFirmePersonali = response.data;
                }
            });
        },

        modificaFirmaPersonale: function(firma) {
            this.nuovaFirma = {
                ID_FIRMA: firma.ID_FIRMA,
                NOME: firma.NOME,
                CONTENUTO_HTML: firma.CONTENUTO_HTML,
            };
        },

resetFirmaPersonaleForm: function() {
            this.nuovaFirma = { ID_FIRMA: 0, NOME: '', CONTENUTO_HTML: '' };
            this.modoEditorFirma = 'visuale';
        },

        salvaFirmaPersonale: function() {
            if (!this.nuovaFirma.NOME || !this.nuovaFirma.CONTENUTO_HTML) {
                utils.alert.warning("Compila il nome e il contenuto della firma.");
                return;
            }
            utils.ajax("core/utente/firme/save", this.nuovaFirma, (response) => {
                if (response.esito == 0) {
                    utils.alert.success(response.messaggio);
                    this.$root.firmeVersion++;
                    this.resetFirmaPersonaleForm();
                    this.caricaFirmePersonali();
                }
            });
        },

        eliminaFirmaPersonale: function(firma) {
            utils.ajax("core/utente/firme/delete", { ID_FIRMA: firma.ID_FIRMA }, (response) => {
                if (response.esito == 0) {
                    utils.alert.success("Firma eliminata.");
                    this.$root.firmeVersion++;
                    this.caricaFirmePersonali();
                }
            });
        },

        salvaPasswordEmail: function() {
            if (!this.utente.PASSWORD_EMAIL) {
                utils.alert.warning("Inserisci una password email.");
                return;
            }
            utils.ajax("core/utente/password-email/update", { PASSWORD_EMAIL: this.utente.PASSWORD_EMAIL }, (response) => {
                if (response.esito == 0) {
                    utils.alert.success(response.messaggio);
                }
            });
        },

    },

    watch: {
        tabSelezionato(newTab) {
            if (newTab === 'configurazioneEmail') {
                this.caricaFirmePersonali();
            }
        }
    },

    computed:{
        paginatedListGruppi(){
            var arr = utils.inGrid(this.arrayGruppi,this.searchGruppi);
            return arr;
        },
        opzioniVerbi() {
            return this.filters.getOpzioniTipologiche(this.idTipologicaVerbi);
        },
    },	   

    created:function(){
        this.arrayEnti = this.filters.toSelect2(this.$root.arrayEnti,'ID_ENTE','LABEL');
        this.arrayGruppi = utils.clone(this.$root.arrayGruppi);
    }

}
</script>